module.exports = __webpack_public_path__ + "img/60066.bb7424c6.png";